import siteConfig from "../data/siteConfig.json";

export const BRAND = siteConfig.brand;

export const CONTACT_INFO = siteConfig.contact;
